/*
 * 検索ボックスの×ボタン。
 *
 * ドロワーと検索ページで同じ部品を使い、ページによっては両方が同時に出る。
 * 個別に結び付けるのではなく document で拾って、後から増えた分にも効くようにする。
 */
(function () {
  'use strict';

  function sync(form) {
    var field = form.querySelector('[data-search-box-field]');
    var clear = form.querySelector('[data-search-box-clear]');
    if (!field || !clear) return;

    // 空のときに×を出しても押すものが無いので、文字が入っている間だけ出す。
    clear.hidden = field.value.length === 0;
  }

  /*
   * 絞り込みのJSはフィルター列全体の input を拾って商品一覧を取り直す。
   * 検索欄はその列の中にあるため、1文字打つたびに一覧が再読み込みされ、
   * 入力中のフォームごと差し替えられてしまう。フォームの時点で止める。
   */
  function bind(form) {
    if (form.getAttribute('data-search-box-bound')) return;
    form.setAttribute('data-search-box-bound', 'true');

    form.addEventListener('input', function (event) {
      event.stopPropagation();
      sync(form);
    });
  }

  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-search-box-clear]');
    if (!clear) return;

    var form = clear.closest('[data-search-box]');
    var field = form.querySelector('[data-search-box-field]');

    field.value = '';
    sync(form);
    field.focus();
  });

  // 空のまま送ると検索結果が0件になる。語を指定しない＝全部見たい、とみなして全商品へ送る。
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-search-box]');
    if (!form) return;

    var field = form.querySelector('[data-search-box-field]');
    var emptyUrl = form.getAttribute('data-search-box-empty-url');

    if (field.value.trim().length === 0 && emptyUrl) {
      event.preventDefault();
      window.location.href = emptyUrl;
    }
  });

  function paint() {
    document.querySelectorAll('[data-search-box]').forEach(function (form) {
      bind(form);
      sync(form);
    });
  }

  // 絞り込みのたびにフィルター列は丸ごと差し替わる。入り直した検索欄にも結び直す。
  function watchSidebar() {
    var sidebar = document.querySelector('[data-collection-sidebar]');
    if (!sidebar) return;

    new MutationObserver(paint).observe(sidebar, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', paint);
  paint();
  watchSidebar();
})();
